/**
 * TagColorPicker — 12 chips de cor da paleta canônica (FEAT-V2-031).
 *
 * Consume `GET /api/v1/tags/palette` pra evitar duplicação de hex strings
 * entre backend e frontend.
 */

import { useTagsPalette } from '@/lib/tags-store';

interface TagColorPickerProps {
  value: string;
  onChange: (cor: string) => void;
  className?: string;
}

export function TagColorPicker({ value, onChange, className = '' }: TagColorPickerProps) {
  const { data } = useTagsPalette();
  const colors = data?.colors ?? [];
  return (
    <div
      data-testid="tag-color-picker"
      className={`flex flex-wrap gap-2 ${className}`}
      role="radiogroup"
      aria-label="Cor da tag"
    >
      {colors.map((cor) => {
        const selected = value === cor;
        return (
          <button
            key={cor}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={`Cor ${cor}`}
            data-testid={`tag-color-${cor}`}
            onClick={() => onChange(cor)}
            style={{ backgroundColor: cor }}
            className={`w-7 h-7 rounded-full transition-all ${
              selected
                ? 'ring-2 ring-offset-2 ring-ink-2 dark:ring-ink-dark-2 scale-110'
                : 'hover:scale-105'
            }`}
          />
        );
      })}
    </div>
  );
}
